











































































import { User } from "@/store/modules/types";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class Login extends Vue {
  username = "";
  password = "";
  async login() {
    const { username, password } = this;
    if (!username || !password) {
      return;
    }
    this.$store.commit("main/SET_LOADING", true);
    try {
      const user: User = await this.$store.dispatch("auth/login", {
        username,
        password,
      });

      if(user.mustChangePassword){
        const data = await this.$store.dispatch("auth/requestPasswordChange");
        const publicId =data["publicId"];
        this.$router.push({ name: "pwd_verify", params: { publicId: publicId }  });
        return;
      }

      const {
        DEFAULT_MODULE,
        ENABLE_GAPS_MODULE,
        ENABLE_SCHEDULE_MODULE,
        ENABLE_CASES_MODULE,
        ENABLE_PATIENTS_MODULE,
        ENABLE_PROVIDERS_MODULE,
        ENABLE_CALLS_MODULE,
      } = user.settings;
      if (DEFAULT_MODULE) {
        switch (DEFAULT_MODULE.toUpperCase()) {
          case "GAPS":
            if (ENABLE_GAPS_MODULE)
              this.$router.push({ name: "gap-dashboard" });
            else {
              this.$modal.show("dialog", {
                title: "WaitingMed",
                text: "<b>Gaps</b> module not <b>enabled</b>.",
              });
            }
            break;
          case "SCHEDULE":
            if (ENABLE_SCHEDULE_MODULE) this.$router.push({ name: "schedule" });
            else {
              this.$modal.show("dialog", {
                title: "WaitingMed",
                text: "<b>Schedule</b> module not <b>enabled</b>.",
              });
            }
            break;
          case "CASES":
            if (ENABLE_CASES_MODULE) this.$router.push({ name: "cases" });
            else {
              this.$modal.show("dialog", {
                title: "WaitingMed",
                text: "<b>Cases</b> module not <b>enabled</b>.",
              });
            }
            break;
          case "PATIENTS":
            if (ENABLE_PATIENTS_MODULE) this.$router.push({ name: "patients" });
            else {
              this.$modal.show("dialog", {
                title: "WaitingMed",
                text: "<b>Patients</b> module not <b>enabled</b>.",
              });
            }
            break;
          case "PROVIDERS":
            if (ENABLE_PROVIDERS_MODULE)
              this.$router.push({ name: "providers" });
            else {
              this.$modal.show("dialog", {
                title: "WaitingMed",
                text: "<b>Providers</b> module not <b>enabled</b>.",
              });
            }
            break;
          case "CALLS":
            if (ENABLE_CALLS_MODULE) this.$router.push({ name: "calls" });
            else {
              this.$modal.show("dialog", {
                title: "WaitingMed",
                text: "<b>Calls</b> module not <b>enabled</b>.",
              });
            }
            break;
        }
      } else {
        if (ENABLE_GAPS_MODULE) {
          this.$router.push({ name: "gap-dashboard" });
        } else if (ENABLE_SCHEDULE_MODULE) {
          this.$router.push({ name: "schedule" });
        } else if (ENABLE_CASES_MODULE) {
          this.$router.push({ name: "cases" });
        } else if (ENABLE_PATIENTS_MODULE) {
          this.$router.push({ name: "patients" });
        } else if (ENABLE_PROVIDERS_MODULE) {
          this.$router.push({ name: "providers" });
        } else if (ENABLE_CALLS_MODULE) {
          this.$router.push({ name: "calls" });
        } else {
          this.$modal.show("dialog", {
            title: "WaitingMed",
            text: "You have no <b>enabled</b> modules.",
          });
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
      this.password = "";
    }
  }
}
